import React, {Component} from 'react'
import { DropdownToggle, ButtonDropdown, DropdownMenu, DropdownItem } from 'reactstrap'
import {listLocal} from "../../helpers/filtersTable"
import {addNewTabSku} from '../../../services/api/apiSku'
import {message} from "antd"
import PubSub from "pubsub-js"

class SkuAddCarrier extends Component {
    state = {
        dropdownOpen: false,
        selectedCarrier: '',
        loading: false,
    }

    _toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        })
    }

    _setSelectedCarrier = (value) => {
        this.setState({
            selectedCarrier: value
        }, () => {
            this._actionAddCarrier()
        })
    }

    _actionAddCarrier = async () => {
        this.setState({
            loading: true
        })

        try {
            const {skuID} = this.props
            const {selectedCarrier} = this.state

            const {data} = await addNewTabSku(skuID, 'shipping-carrier', selectedCarrier)
            
            const {success, message: messApi} = data

            if(!success) return this.setState({
                loading: false
            }, () => {
                message.error(messApi)
            })

            message.success('Thêm mới Shipping carrier thành công!')
            PubSub.publish('GET_LIST_TAB')

            this.setState({
                loading: false
            })
        } catch (e) {
            this.setState({
                loading: false
            }, () => {
                message.error(e.message)
            })
        }
    }

    render() {
        const {listTab} = this.props
        const {loading} = this.state
        const listShippingActive = listTab.filter(item => item.type === 'shipping-carrier').map(item => item.name)

        return (
            <div className="SkuAddCarrier mb-3 d-flex justify-content-end">
                <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this._toggle}>
                    <DropdownToggle disabled={loading} caret color="primary">
                        Thêm Shipping carrier
                    </DropdownToggle>
                    <DropdownMenu right={true}>
                        {
                            listLocal.map((option, index) => {

                                const {name, value} = option

                                return (value !== '' &&
                                    <DropdownItem disabled={listShippingActive.includes(value)} key={index} onClick={() => this._setSelectedCarrier(value)}>{name}</DropdownItem>)
                            })
                        }
                    </DropdownMenu>
                </ButtonDropdown>
            </div>
        )
    }
}

SkuAddCarrier.propTypes = {

}

export default SkuAddCarrier